import { objectToQueryString } from '../objectToQueryString';

export default class BingSearch {
	constructor(config) {
		this.config = config;
		this.start = 0;
	}

	reset() {
		this.start = 0;
	}

	/* Bing Specific Search Configs */
	getRequest(options) {
		const params = {
			q: options.query,
			customconfig: this.config.customConfig,
			mkt: this.config.market,
			count: this.config.count,
			offset: options.start || this.start, // < (totalEstimatedMatches - count).
			setLang: options?.lr?.split('_')[1] || 'EN'
		};

		const url = `${this.config.url}?${objectToQueryString(params)}`;
		return { params, url };
	}

	getOptions() {
		return {
			mode: 'cors',
			headers: {
				'Ocp-Apim-Subscription-Key': this.config.key
			}
		};
	}

	transformData(data) {
		// object - nextpage,item,corrected query,
		const resultObj = {
			items: [],
			searchInformation: {},
			queries: {}
		};
		const totalCount = data?.webPages?.totalEstimatedMatches || 0;
		// setting corrected
		const correctedQuery = data.queryContext?.alteredQuery || null;
		if (correctedQuery) {
			resultObj.spelling = {
				correctedQuery: correctedQuery + ' bingCorrected'
			};
		}
		resultObj.searchInformation.totalResults = totalCount;
		// transforming results items
		resultObj.items =
			data?.webPages?.value.map(item => {
				return {
					kind: 'customsearch#result', // non promoted content
					title: item.name || '',
					htmlSnippet: item.snippet || '',
					link: item.url,
					formattedUrl: item.displayUrl,
					htmlTitle: item.name
				};
			}) || [];
		return resultObj;
	}

	parseResponse(data) {
		if (Array.isArray(data)) {
			return data.map(searchResult => this.transformData(searchResult));
		}
		return this.transformData(data);
	}
}
